<template>
  <div>
    <CCLFReport_CostUtilization
      v-if="activeView === 'cost-utilization'"
      :contract-id="contractId"
      :performance-year="performanceYear"
      :dosthru="dosthru"
      :entity-id="entityId"
    />
    <CCLFReport_OutpatientSummary
      v-else-if="activeView === 'outpatient-summary'"
      :contract-id="contractId"
      :performance-year="performanceYear"
      :dosthru="dosthru"
      :entity-id="entityId"
    />
    <CCLFReport_DRGReport
      v-else-if="activeView === 'drg-report'"
      :contract-id="contractId"
      :performance-year="performanceYear"
      :dosthru="dosthru"
      :entity-id="entityId"
    />
    <CCLFReport_Hospice
      v-else-if="activeView === 'hospice'"
      :contract-id="contractId"
      :performance-year="performanceYear"
      :dosthru="dosthru"
      :entity-id="entityId"
    />
    <CCLFReport_TherapyDeepDive
      v-else-if="activeView === 'therapy'"
      :contract-id="contractId"
      :performance-year="performanceYear"
      :dosthru="dosthru"
      :entity-id="entityId"
    />
    <ACSCCascadeSankey
      v-else-if="activeView === 'acsc-cascade'"
      :entity-id="Number(entityId)"
      :year="performanceYear"
    />
    <External_TOC_Page
      v-else-if="activeView === 'chained_episodes'"
      :entity-id="entityId"
    />
  </div>
</template>

<script>
import CCLFReport_CostUtilization from './CCLFReport/CCLFReport_CostUtilization.vue';
import CCLFReport_OutpatientSummary from './CCLFReport/CCLFReport_OutpatientSummary.vue';
import CCLFReport_DRGReport from './CCLFReport/CCLFReport_DRGReport.vue';
import CCLFReport_Hospice from './CCLFReport/CCLFReport_Hospice.vue';
import CCLFReport_TherapyDeepDive from './CCLFReport/CCLFReport_TherapyDeepDive.vue';
import External_TOC_Page from './External_TOC_Page.vue';
import ACSCCascadeSankey from '@/components/InsightsNew/ACSCCascadeSankey.vue';

export default {
  name: 'ExternalUtilization',
  components: {
    CCLFReport_CostUtilization,
    CCLFReport_OutpatientSummary,
    CCLFReport_DRGReport,
    CCLFReport_Hospice,
    CCLFReport_TherapyDeepDive,
    ACSCCascadeSankey,
    External_TOC_Page,
  },
  props: {
    entityId: { type: [Number, String], default: null },
    activeView: { type: String, default: 'cost-utilization' },
  },
  data() {
    return {
      contractId: 'A5069',
      performanceYear: 2026,
      dosthru: null,
    };
  },
};
</script>
